import { getRoleLabel, getBusinessName } from "./constants";

export const formatAuditDate = (date) => {
  if (!date) return "-";

  return new Date(date).toLocaleString("es-AR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const getAuditActionLabel = (action) => {
  switch (action) {
    case "move_business":
      return "Mover unidad de negocio";
    case "restore":
      return "Restaurar";
    case "create":
      return "Crear";
    case "delete":
      return "Eliminar";
    case "update":
      return "Actualizar";
    case "update_business_access":
      return "Actualizar unidad de negocio";
    default:
      return action || "-";
  }
};

export const getAuditPerformedBy = (log) => {
  return (
    log?.performed_by_user?.username ||
    log?.performed_by_user?.email ||
    log?.performed_by ||
    "-"
  );
};

export const getAuditAffectedUser = (log) => {
  const username = log?.after?.username || log?.before?.username;
  const email = log?.after?.email || log?.before?.email;

  if (username && email) return `${username} - ${email}`;
  if (username) return username;
  if (email) return email;

  return "-";
};

const getFieldLabel = (field) => {
  const labels = {
    username: "Nombre",
    email: "Email",
    role_id: "Rol",
    status: "Estado",
    business_id: "Unidad de negocio",
    relation_user_id: "Usuario relacionado",
    current_business_id: "Unidad de negocio actual",
    allowable_business_ids: "Unidades de negocio habilitadas",
    user_id: "Usuario",
  };

  return labels[field] || field;
};

const formatValue = (field, value) => {
  if (value === null || value === undefined || value === "") return "-";

  if (field === "status") {
    if (Number(value) === 1) return "Activo";
    if (Number(value) === 9) return "Eliminado";
  }

  if (field === "role_id") {
    return getRoleLabel(value);
  }

  if (field === "business_id" || field === "current_business_id") {
    return getBusinessName(value);
  }

  if (field === "allowable_business_ids" && Array.isArray(value)) {
    return value.length ? value.map((id) => getBusinessName(id)).join(", ") : "-";
  }

  return String(value);
};

export const getAuditDetailRows = (log) => {
  const before = log?.before || {};
  const after = log?.after || {};

  const isContext = log?.entity_type === "user_business_context";

  const fields = isContext
    ? ["user_id", "current_business_id", "allowable_business_ids"]
    : [
        "username",
        "email",
        "role_id",
        "status",
        "business_id",
      ];

  return fields
    .map((field) => {
      const beforeValue = formatValue(field, before[field]);
      const afterValue = formatValue(field, after[field]);

      return {
        field,
        label: getFieldLabel(field),
        before: beforeValue,
        after: afterValue,
      };
    })
    .filter((row) => row.before !== row.after);
};